module.exports = __webpack_public_path__ + "img/PAPER.7ec42d9d.svg";